import React from "react";

export const IconSecure: React.FC = () => {
	return (
		<svg
			width="23"
			height="26"
			viewBox="0 0 23 26"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.0186 4.19141C21.5123 4.37336 21.875 4.80047 21.9736 5.31738C22.0722 5.83441 21.8923 6.36583 21.5 6.7168L10.9424 16.1631L5.93945 11.1592L8.06055 9.03809L11.0566 12.0342L17.6406 6.14355L11 3.69629L3 6.64355V14.7598C3.9017 16.5836 5.70556 18.4144 7.54883 19.8545C8.49578 20.5943 9.40468 21.1939 10.1182 21.6006C10.4765 21.8048 10.7666 21.9494 10.9746 22.0381C10.9874 22.0435 11.0002 22.047 11.0117 22.0518C11.0157 22.0501 11.0203 22.0496 11.0244 22.0479C11.2104 21.9717 11.4741 21.8426 11.8027 21.6523C12.4576 21.2732 13.302 20.6892 14.2021 19.9053C16.0075 18.3328 18.5 15.417 19 14.0986C20 12.5986 21.2707 11.8503 21.9004 11.5986C22.2803 11.4468 22.1975 13.3636 21.9004 14.1367C20.5406 17.6722 18.2423 20.3645 16.1729 22.167C15.1357 23.0703 14.136 23.7678 13.3066 24.248C12.8933 24.4874 12.5043 24.6827 12.1611 24.8232C11.8784 24.9391 11.4407 25.0986 11 25.0986C10.5351 25.0986 10.0681 24.9126 9.79883 24.7979C9.45229 24.6502 9.05456 24.447 8.63184 24.2061C7.78302 23.7222 6.75388 23.0402 5.70117 22.2178C3.63595 20.6043 1.27873 18.2951 0.128906 15.708L0 15.417V5.59863L0.00488281 5.48145C0.0501603 4.90123 0.42873 4.39508 0.981445 4.19141L11 0.5L21.0186 4.19141Z"
				fill="currentColor"
			/>
		</svg>
	);
};
